import * as React from 'react';
import { Home, Layers, Settings,  Box, Database, Grid } from 'react-feather';

/**
 * Gestion du breadcrumb
 * @param  {any}    emitter [description]
 * @return {[type]}         [description]
 */
export default function Listener(emitter: any): any {
  emitter.on({
    event: 'sidebar:menu',
    resolver: async ({ i18n }: any) => {
      return [
        {
          icon: <Home size={23} />,
          label: i18n.t('home'),
          link: '/',
          slug: 'home',
        },
        {
          icon: <Grid size={23} />,
          label: i18n.t('Pre trained'),
          link: '/pre-trained',
          actives: [
            '/text',
            '/face',
            '/nlu',
            '/table',
            '/:language/companies/:companyId/inference/invoice',
            '/:language/companies/:companyId/inference/receipt',
            '/:language/companies/:companyId/inference/liasse-fiscale',
            '/:language/companies/:companyId/inference/bank-statements',
            '/:language/companies/:companyId/inference/driverLicense',
            '/bounding-box',
          ],
          slug: 'pre-trained',
        },
        {
          icon: <Database size={23} />,
          label: i18n.t('Datalabs'),
          link: '/:language/companies/:companyId/projects',
          slug: 'datalabs',
        },
        {
          icon: <Box size={23} />,
          label: i18n.t('Knowledge Vision'),
          link: '/:language/companies/:companyId/trains',
          slug: 'knowledge-vision',
        },
        {
          icon: <Layers size={23} />,
          label: i18n.t('Analytics'),
          link: '/:language/companies/:companyId/analytics',
          slug: 'analytics',
        },
        {
          icon: <Settings size={23} />,
          label: i18n.t('Account'),
          link: '/:language/companies/:companyId/account',
          slug: 'account',
        },
      ];
    },
  });
}



// WEBPACK FOOTER //
// ./src/listeners/nav/index.tsx